import { BaseController } from '@/api/BaseController';
import { RequestOption } from '@/common/http/types';
import { ANY_OBJECT } from '@/types/generic';
import { TableData } from '@/common/types/table';
import { useUrlBuilder } from '@/common/hooks/useUrl';
import PlatformWldlUserCertificate from '@/types/table/platformWldlUserCertificate';
import { PlatformUserData } from '@/api/generated/platformUserController';
import { API_CONTEXT } from '../config';

const { buildGetUrl } = useUrlBuilder();

export interface PlatformWldlUserCertificateData extends PlatformWldlUserCertificate {
  platformUser?: PlatformUserData;
  __cascade_add_temp_id__?: string | number | undefined;
}

export default class PlatformWldlUserCertificateController extends BaseController {
  static list(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post<TableData<PlatformWldlUserCertificateData>>(API_CONTEXT + '/app/platformWldlUserCertificate/list', params, httpOptions);
  }
  static view(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.get<PlatformWldlUserCertificateData>(API_CONTEXT + '/app/platformWldlUserCertificate/view', params, httpOptions);
  }
  static export(params: ANY_OBJECT, fileName: string) {
    return super.download(API_CONTEXT + '/app/platformWldlUserCertificate/export', params, fileName);
  }
  static import(params: ANY_OBJECT) {
    return super.upload(API_CONTEXT + '/app/platformWldlUserCertificate/import', params);
  }
  static printUrl(params: ANY_OBJECT) {
    return buildGetUrl(API_CONTEXT + '/app/platformWldlUserCertificate/print', params);
  }
  static add(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/platformWldlUserCertificate/add', params, httpOptions);
  }
  static update(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/platformWldlUserCertificate/update', params, httpOptions);
  }
  static regenerate(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/platformWldlUserCertificate/regenerate', params, httpOptions);
  }
  static delete(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/platformWldlUserCertificate/delete', params, httpOptions);
  }
  static deleteBatch(params: ANY_OBJECT, httpOptions?: RequestOption) {
    return super.post(API_CONTEXT + '/app/platformWldlUserCertificate/deleteBatch', params, httpOptions);
  }
}
